<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  created (){
//禁止ctrl+鼠标滚轮缩放页面
    window.addEventListener('mousewheel', function (event) {
      if (event.ctrlKey === true || event.metaKey) {
        event.preventDefault();
      }
    }, { passive: false });

//firefox
    window.addEventListener('DOMMouseScroll', function (event) {
      if (event.ctrlKey === true || event.metaKey) {
        event.preventDefault();
      }
    }, { passive: false });
//禁止ctrl + 加号，ctrl + 减号缩放页面
    $(document).keydown(function (event) {
      //event.metaKey mac的command键
      //mac下chrome: - 189, + 187 firefox: - 173, + 61,
      //数字键盘: + 107, - 109
      if ((event.ctrlKey === true || event.metaKey === true) &&
              (event.which === 189 || event.which === 187
                      || event.which === 173 || event.which === 61
                      || event.which === 107 || event.which === 109)) {
        event.preventDefault();
      }
    });
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue